export function getOrderLoading(state) {
    return state.OrderReducer.isLoading;
}

export function getOrders(state) {
    return state.OrderReducer.orders;
}
